<template>
  <section>
    <!--工具条-->
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters">
          <el-form-item label="">
            <LinkageRole @roleSelected="roleSelected" @comSelected="comSelected" @proSelected="proSelected"
                         :option="0" :limit-seleced="limitSelected"></LinkageRole>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="姓名/电话搜索" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSerch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="showAddView">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="doExport">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--列表-->
    <template>
      <el-table :data="datas" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="comPhoto" label="照片" align="center" width="100">
          <TableImg :data="scope.row.employeePhoto" slot-scope="scope"></TableImg>
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" width="90" align="center">
        </el-table-column>
        <el-table-column prop="employeeGender" label="性别" width="50" :formatter="formatSex" align="center">
        </el-table-column>
        <el-table-column prop="employeeTel" label="联系电话" width="120" align="center">
        </el-table-column>
        <el-table-column prop="user.comName" label="公司" align="center">
        </el-table-column>
        <el-table-column prop="user.projectName" label="项目" align="center">
          <template slot-scope="scope">
            <span v-for="(item,index) in JSON.parse(scope.row.user.projectName)" style="margin-right: 10px;">{{item.proName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roleNames" label="岗位" align="center">
        </el-table-column>
        <el-table-column prop="employeeDisclose" label="交底单" width="80" align="center">
          <template slot-scope="scope">
            <a href="javascript:void(0)" @click="downloadFile(scope.row.employeeDisclose)" class="download"
               title="下载交底单">查看</a>
          </template>
        </el-table-column>
        <el-table-column prop="employeeContract" label="劳动合同" width="80" align="center" :formatter="formatDate">
          <template slot-scope="scope">
            <a href="javascript:void(0)" @click="downloadFile(scope.row.employeeContract)" class="download"
               title="下载劳动合同">查看</a>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <!--            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>-->
            <el-button size="small"  @click="qrcodeView(scope.$index, scope.row)">二维码</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
        <UserForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData" :type="0"></UserForm>
      </div>
    </el-dialog>

    <!-- 二维码视图 -->
    <el-dialog :visible.sync="qrcodeVisible" title="查看二维码" :modal="false" :close-on-click-modal="false">
      <div class="q-title" style="text-align: center">{{qrcodeMes}}</div>
      <div slot="footer">
        <div id="qrcode"></div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import {
    userSearch, userDel, userDetail,userExport
  } from '../../api/api'
  import UserForm from "./UserForm";
  import TableImg from "../command/TableImg";
  import LinkageRole from "./LinkageRole";
  import QRCode from 'qrcodejs2';
  export default {
    components: {UserForm, TableImg,LinkageRole},
    data() {
      return {
        datas: [],
        page: 1,
        total: 0,
        limit: 15,
        filters: {proId:null,},
        proVisible: false,
        formVisible: false,
        detailsVisible: false,
        loading: false,
        option: 0,//0 添加 1 修改
        formData: {},
        limitSelected:1,
        comId:null,
        proId:null,
        roleId:null,
        qrcodeVisible:false,
        qrcodeMes:null
      }
    },
    methods: {
      doExport:function(){
        let params = {
          page: 1, limit: 10000, searchTab: this.filters.searchTab,isManager:0,
          comId: this.comId!=0 ? this.comId:null, proId: this.proId!=null ? this.proId[0]:null,roleId : this.roleId!=null ? this.roleId[0]:null
        };//请求参数
        let header = {headers: {'token': this.GLOBAL.user.token},responseType:'blob'}
        userExport(params, header).then(result => {
          const content = result.data
          const blob = new Blob([content])//构造一个blob对象来处理数据
          //获取后台文件名
          let realFileName ='工人列表.xls';
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob,realFileName);
          } else {
            let link = document.createElement('a');
            link.href =  window.URL.createObjectURL(blob);
            link.download = realFileName;
            //兼容火狐浏览器
            document.body.appendChild(link);
            let evt = document.createEvent("MouseEvents");
            evt.initEvent("click", false, false);
            link.dispatchEvent(evt);
            document.body.removeChild(link);
          }
        });
      },
      //查询数据
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.user, this.GLOBAL.option.select, this);

        this.loading = true;
        let params = {
          page: this.page, limit: this.limit, searchTab: this.filters.searchTab,isManager:0,
          comId: this.comId!=0 ? this.comId:null, proId: this.proId!=null ? this.proId[0]:null,roleId : this.roleId!=null ? this.roleId[0]:null
        };//请求参数

        userSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.datas = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });

      },
      //查询
      doSerch: function () {
        this.searchData();
      },
      //分页查询
      searchPage(val) {
        this.page = val
        this.searchData();
      },
      resetForm: function () {
        this.filters = {}
      },
      //添加视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.user, this.GLOBAL.option.create, this);
        if (res) {
          this.formData = {user: {}}
          this.option = 0;
          this.formVisible = true;
        }

      },
      //编辑视图
      showEditView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.user, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          userDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.user, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            userDel({id: row.user.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }

      },
      //查看详情
      openDetails: function (index, row) {
        this.GLOBAL.checkRole(null, null);
        this.detailsVisible = true
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.updateTime, "yyyy-MM-dd hh:mm:ss");
      },

      //性别显示转换
      formatSex: function (row, column) {
        return row.employeeGender == 1 ? '男' : row.employeeGender == 0 ? '女' : '未知'
      },
      //=====下载文件方法====================================================
      downloadFile: function (file) {
        if (file != null && file != '') {
          let url = this.GLOBAL.baseFilePath + file;    // 获取图片地址
          let a = document.createElement('a');          // 创建一个a节点插入的document
          let event = new MouseEvent('click')       // 模拟鼠标click点击事件
          a.download = 'beautifulGirl'                  // 设置a节点的download属性值
          a.href = url;                                 // 将图片的src赋值给a节点的href
          a.dispatchEvent(event)                        // 触发鼠标点击事件
        }
      },

      comSelected: function (id) {
        this.comId = id;
      },
      proSelected: function (proId) {
        this.proId = proId;
      },
      roleSelected:function(roleId) {
        this.roleId = roleId;
      },
      qrcodeView(index, row) {
        this.qrcodeVisible = true
        this.qrcodeMes = row.employeeName;
        this.qrcode.makeCode(this.GLOBAL.baseDomainUrl + '/userview?id=' + row.id);
      },
      showQEcodeView: function () {
        this.qrcode = new QRCode('qrcode', {
          width: 150, //图像宽度
          height: 150, //图像高度
          colorDark: '#000000', //前景色
          colorLight: '#ffffff', //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
      },
    },
    mounted() {
      if (this.GLOBAL.proList.length > 0) {
        this.filters.proId = this.GLOBAL.proList[0].id;
      }
      this.doSerch();
      this.showQEcodeView();
    }
  }
</script>
<style scoped lang="scss">
  @import "../../assets/global-vars";

  .groupbox {
    border-right: 1px solid $border;
    height: 500px;
  }

  .download {
    text-decoration: none;
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Worker.vue